module.exports = __webpack_public_path__ + "img/service_programming.cd4b2bff.png";